<template>
  <div class="activeDetail active">
    <van-cell-group class="info">
      <van-cell title="活动名称">
        <p class="item2"> {{report.campName}}</p>
      </van-cell>
      <van-cell title="活动日期">
        <p class="item2">{{report.U_RangeTime}}</p>
      </van-cell>
      <van-cell title="活动地点">
        <p class="item2"> {{report.U_CampPlace}}</p>
      </van-cell>
      <van-cell title="预计人数">
        <p class="item2"> {{$numeral(report.U_InvitedCnt).format('0,0')}}</p>
      </van-cell>
      <van-cell title="到场人数">
        <p class="item2"> {{$numeral(report.U_OnSiteCnt).format('0,0')}}</p>
      </van-cell>
      <van-cell title="集客目标">
        <p class="item2"> {{$numeral(report.U_FansTarget).format('0,0')}}</p>
      </van-cell>
      <van-cell title="集客人数">
        <p class="item2"> {{$numeral(report.U_CollectionCnt).format('0,0')}}</p>
      </van-cell>
      <van-cell title="销售目标">
        <p class="item2"> {{$numeral(report.U_SalesTarget).format('0,0')}}</p>
      </van-cell>
      <van-cell title="调查问卷">
        <p class="item2"> {{report.U_Survey==1?'有':'没有'}}</p>
      </van-cell>
      <van-cell title="完成人数">
        <p class="item2"> {{$numeral(report.U_SurveyCnt).format('0,0')}}</p>
      </van-cell>

    </van-cell-group>


    <van-cell-group class="group group-table">
      <van-cell   @click="showYusuan=!showYusuan">
        <template slot="title">
          <span class="custom-text">实际费用</span>
          <span class="mini-text">（未税{{$numeral(totalBudget.amount||0).format('0,0.00')}}，含税{{$numeral(totalBudget.unamount||0).format('0,0.00')}}）</span>
        </template>
        <van-icon slot="right-icon" name="arrow-down" class="custom-icon" size="20px" />
      </van-cell>
      <div class="table van-hairline--surround" v-if="showYusuan">
        <div class="table-title flex ">
          <p class="item1">序号</p>
          <p class="item2">名称</p>
          <p class="item1">数量</p>
          <p class="item3">未税费用</p>
          <p class="item3">含税费用</p>
        </div>
        <template v-for="(item,index) in costList">
          <ul class="table-content flex van-hairline--top">
            <li class="item1 van-hairline--right">{{index+1}}</li>
            <li class="item2 van-hairline--right">{{item.Name}}</li>
            <li class="item1 van-hairline--right">{{$numeral(item.U_Qty).format('0,0')}}</li>
            <li class="item3 van-hairline--right">{{$numeral(item.U_Amount).format('0,0.00')}}</li>
            <li class="item3 flex">
              <p class="item1">{{$numeral(item.U_AmountAftTax).format('0,0.00')}}</p>
            </li>
          </ul>
        </template>

        <ul class="table-content flex van-hairline--top">
          <li class="item3 van-hairline--right">合计</li>
          <li class="item1 van-hairline--right">{{$numeral(totalBudget.count||0).format('0,0')}}</li>
          <li class="item3 van-hairline--right">{{$numeral(totalBudget.amount||0).format('0,0.00')}}</li>
          <li class="item3">{{totalBudget.unamount||0}}</li>
        </ul>
      </div>
      <div class="flex" v-if="showYusuan">
        <p class="upload-img " v-for="(img,index) in costImgList">
          <img :src="$config.serverURL+'upload/'+img.U_url" @click="previewList(costImgList,index)">
        </p>
      </div>
    </van-cell-group>

    <van-cell-group class="group group-table">
      <van-cell   @click="showSales=!showSales">
        <template slot="title">
          <span class="custom-text">当天销售情况</span>
        </template>
        <van-icon slot="right-icon" name="arrow-down" class="custom-icon" size="20px" />
      </van-cell>
      <div class="table van-hairline--surround" v-if="showSales">
        <div class="table-title flex ">
          <p class="item2">序号</p>
          <p class="item3">产品一级分类</p>
          <p class="item2">产品名称</p>
          <p class="item2">金额</p>
        </div>
        <template v-for="(item,index) in saleList">
          <ul class="table-content flex van-hairline--top">
            <li class="item2 van-hairline--right">{{index+1}}</li>
            <li class="item3 van-hairline--right">{{item.productClass1Name}}</li>
            <li class="item2 van-hairline--right">{{item.U_ProductName}}</li>
            <li class="item2 ">{{$numeral(item.U_Amount).format('0,0.00')}}</li>
          </ul>
        </template>
      </div>
    </van-cell-group>

    <!--<van-cell-group class="group group-table">-->
      <!--<van-cell   >-->
        <!--<template slot="title">-->
          <!--<span class="custom-text">活动后30天销售情况</span>-->
        <!--</template>-->
      <!--</van-cell>-->
      <!--<div class="table van-hairline&#45;&#45;surround">-->
        <!--<div class="table-title flex ">-->
          <!--<p class="item2">序号</p>-->
          <!--<p class="item3">产品一级分类</p>-->
          <!--<p class="item2">产品名称</p>-->
          <!--<p class="item3">金额</p>-->
        <!--</div>-->
        <!--<template v-for="(item,index) in saleMonthList">-->
          <!--<ul class="table-content flex van-hairline&#45;&#45;top">-->
            <!--<li class="item2 van-hairline&#45;&#45;right">{{index+1}}</li>-->
            <!--<li class="item3 van-hairline&#45;&#45;right">{{item.productClass1Name}}</li>-->
            <!--<li class="item2 van-hairline&#45;&#45;right">{{item.Name}}</li>-->
            <!--<li class="item3 flex">-->
              <!--<p class="item1 van-hairline&#45;&#45;right">{{item.U_Amount}}</p>-->
              <!--<van-icon name="cross" class="close" @click.stop="saleMonthList.splice(index,1)"/>-->
            <!--</li>-->
          <!--</ul>-->
        <!--</template>-->
        <!--<div class="table-content add-table van-hairline&#45;&#45;top" @click="showSalesmonth=!showSalesmonth">-->
          <!--+添加一栏-->
        <!--</div>-->
      <!--</div>-->
    <!--</van-cell-group>-->

    <van-cell-group class="group group-table" v-if="report.U_ApprovalStatus=='Y' || report.U_ApprovalStatus=='MSM'">
      <van-cell   @click="showMonth=!showMonth">
        <template slot="title" >
          <span class="custom-text">活动后30天销售情况</span>
        </template>
        <van-icon slot="right-icon" name="arrow-down" class="custom-icon" size="20px" />
      </van-cell>
      <div class="table van-hairline--surround" v-if="showMonth">
        <div class="table-title flex ">
          <p class="item2">序号</p>
          <p class="item3">产品一级分类</p>
          <p class="item2">产品名称</p>
          <p class="item3">金额</p>
        </div>
        <template v-for="(item,index) in saleMonthList">
          <ul class="table-content flex van-hairline--top" @click="saleEdit(item,index)">
            <li class="item2 van-hairline--right">{{index+1}}</li>
            <li class="item3 van-hairline--right">{{item.U_ProductClass1 || item.productClass1Name}}</li>
            <li class="item2 van-hairline--right">{{item.U_ProductName}}</li>
            <li class="item3 flex">
              <p class="item1 van-hairline--right">{{$numeral(item.U_Amount).format('0,0.00')}}</p>
              <van-icon name="cross" class="close" @click.stop="saleMonthList.splice(index,1)" v-if="(isApply && !isSalesMonthApproval && !hasSalesMonth)  || (report.U_ApprovalStatus=='MSM' && isApply)"/>
            </li>
          </ul>
        </template>
        <div class="table-content add-table van-hairline--top" @click="saleEdit('new')" v-if="(isApply && !isSalesMonthApproval && !hasSalesMonth) || (report.U_ApprovalStatus=='MSM' && isApply)">
          +添加一栏
        </div>
      </div>
    </van-cell-group>

    <van-cell-group class="group">
      <van-cell   @click="showZongjie=!showZongjie">
        <template slot="title" >
          <span class="custom-text">活动总结</span>
        </template>
        <van-icon slot="right-icon" name="arrow-down" class="custom-icon" size="20px" />
      </van-cell>
      <div class="cell-content" v-html="report.U_Summary" v-if="showZongjie">
      </div>
    </van-cell-group>

    <van-cell-group class="group">
      <van-cell title="现场照片"  />
      <div class="clear">
        <p class="upload-img fl" v-for="(img,index) in reportImgList">
          <img :src="$config.serverURL+'upload/'+img.U_url" @click="previewList(reportImgList,index)">
        </p>
      </div>
    </van-cell-group>

    <van-cell-group class="group">
      <van-cell title="审批记录" >
        <van-icon slot="right-icon" name="arrow-down" class="custom-icon" size="20px" @click="showShenpi=!showShenpi"/>
      </van-cell>
      <ul class="steps" v-if="showShenpi">
        <template v-for="item in flowRecordList">
          <li class="step">
            <van-icon v-if="item.approvalFlow&&item.approvalFlow.U_Status=='N'" name="clear" class="step-icon" color="#e83c39"  size="20px"/>
            <van-icon v-else-if="item.approvalFlow&&item.approvalFlow.U_Status=='Y'" name="checked" class="step-icon"  color="#02c316"  size="20px"/>
            <van-icon v-else name="play-circle"  class="step-icon" color="#8bc34a" size="20px"/>
            <div>
              <p class="flex">
                <span class="item1">{{item.approvalFlow.createTime}}</span>
                <span class="item1">{{item.approvalFlow.salesName}}</span>
              </p>
              <p v-if="item.approvalFlow&&(item.approvalFlow.U_Status=='S' || item.approvalFlow.U_Status=='M')">提交 {{item.approvalFlow.U_Remark}}</p>
              <p v-if="item.approvalFlow&&item.approvalFlow.U_Status=='D'">{{item.approvalFlow.U_Remark}}</p>
              <p v-if="item.approvalFlow&&(item.approvalFlow.U_Status=='N'||item.approvalFlow.U_Status=='Y')">审批备注：{{item.approvalFlow.U_Remark}}</p>
              <p class="clear">
                <template v-for="img in item.imgList">
                  <img :src="$config.serverURL+'upload/'+img.U_url" class="step-img fl" @click="previewList(item.imgList,index)">
                </template>
              </p>
            </div>
          </li>
        </template>
      </ul>
      <p class="text-center" v-if="showShenpi&&flowRecordList.length==0">暂无审批记录</p>
    </van-cell-group>

    <van-cell-group class="group" v-if="isApproval || isSalesMonthApproval">
      <van-cell title="审批备注"  />
      <van-field
        class="textarea van-hairline--surround"
        type="textarea"
        placeholder="请输入备注内容描述"
        rows="3"
        autosize
        v-model="remark"
      />
      <div class="clear">
        <template v-for="(img,index) in imgs">
          <p class="upload-img fl">
            <img :src="$config.serverURL+'upload/'+img" @click="previewList(imgs,index)">
            <van-icon name="clear" class="del-icon" color="#e83c39"  size="20px" @click="delImg(index)"/>
          </p>
        </template>
        <van-uploader  class="upload fl" :after-read="afterRead" multiple>
          <van-icon name="plus" />
          <p>上传图片</p>
        </van-uploader>
      </div>
    </van-cell-group>

    <div class="bottom-btn flex" v-if="isApply && hasModifyAuth">
      <div class="item1 btn save" v-if="report.U_ApprovalStatus=='D'||report.U_ApprovalStatus=='N'" @click="toReply">修改</div>
      <div class="item1 btn save" v-if="((report.U_ApprovalStatus=='Y' && !isSalesMonthApproval && isApply  && !hasSalesMonth) || (report.U_ApprovalStatus=='MSM' && isApply))" @click="submitSaleAfterMonth">提交</div>
      <div class="item1 btn sub" @click="getPdf">生成pdf</div>
    </div>
    <div class="bottom-btn flex" v-else-if="isApproval && !isSalesMonthApproval">
      <div class="item1 btn save"  v-if="report.U_ApprovalStatus=='W' && hasAuditAuth" @click="sub(2)">拒绝</div>
      <div class="item1 btn sub" v-if="report.U_ApprovalStatus=='W' && hasAuditAuth" @click="sub(1)">审批</div>
      <div class="item1 btn sub" v-if="report.U_ApprovalStatus=='Y' || !hasAuditAuth" @click="getPdf">生成pdf</div>
    </div>
    <div class="bottom-btn flex" v-else-if="isSalesMonthApproval">
      <div class="item1 btn save" @click="sub(2)">拒绝</div>
      <div class="item1 btn sub" @click="sub(1)">审批</div>
    </div>
    <div class="bottom-btn flex" v-else>
      <div class="item1 btn sub" @click="getPdf">生成pdf</div>
    </div>
    <salesPop  v-model="showSalesmonth" @newSales="newSalesmonth" :info="salesmonthValue"></salesPop>
  </div>
</template>
<script>
  import apiActive from '@/api/active'
  import moment from 'moment'
  import salesPop from './component/salesPop.vue'
  import $config  from '@/config/config';
  import {ImagePreview} from 'vant'
  import imageCompression from 'browser-image-compression';

  export default{
    data(){
      return {
        id:'',
        report:{},  //基本信息
        costList:[],  //活动实际费用列表
        costImgList:[], //实际费用列表
        saleList:[], //活动当天销售情况
        saleMonthList:[], //活动三十天后销售情况
        flowRecordList:[], //审批记录
        reportImgList:[],  //现场活动图片列表

        showYusuan:false,
        showSales:false,
        showMonth:false,
        showShenpi:false,
        showZongjie:false,


        isApply:false,  //是否为活动申请人
        isApproval:false,  //是否为审批人
        isSalesMonthApproval:false,  //是否为30天销售情况审批人
        hasSalesMonth : false, //是否已提交30天销售情况


        remark:'', //审批备注
        imgs:[],

        showSalesmonth:false, //30天后销售情况
        salesmonthValue:{},
        salesList:[],
        hasModifyAuth : true, //是否有修改权限
        hasAuditAuth : true, //是否有审批权限
      }
    },
    components:{
      salesPop
    },
    filters: {
      getDate: function (value) {
        if (!value) return ''
        return moment(parseInt(value)).format('YYYY-MM-DD')
      },
      getTime: function (value) {
        if (!value) return ''
        console.log(this)
        return moment(parseInt(value)).format('HH:mm:ss')
      }
    },
    computed:{
      totalBudget(){//活动预算合计
        let count= 0,amont = 0, unamont = 0
        for( var item of this.costList){
          count +=parseInt(item.U_Qty||0)
          amont +=parseFloat(item.U_Amount||0)
          unamont +=parseFloat(item.U_AmountAftTax||0)
        }
        console.log(count, amont, unamont)
        let data = {
          count: count, amount:this.$validator().towDecimal(amont+''), unamount: this.$validator().towDecimal(unamont+'')
        }
        return data
      },
      imgUrl(){ //图片地址
        let str = ''
        if(this.imgs.length>99){
            this.$title('最多不能超过99张')
            return
        }
        for(var key in  this.imgs){
          if(key<this.imgs.length-1){
            str+=this.imgs[key]+','
          }else{
            str+=this.imgs[key]
          }
        }
        return str
      },
      totalMaterial(){//物料合计
        let count= 0
        for( var item of this.materialList){
          count +=parseInt(item.U_Qty||0)
        }
        return count
      },
    },
    watch:{
      'report.U_RangeTime':function(){
        if(this.report.U_RangeTime){
          this.report.U_RangeTime = this.report.U_RangeTime.replace(',','至')
        }
      }
    },
    methods:{
      getDetail(){
        this.$api.$active.reportDetail({
          salesId:this.$wxuserUtil.getUserId(),
          id:this.$route.query.id
        }).then(response=>{
          if(response.success==true){
            this.report = response.data.report
            this.costList = response.data.costList
            this.costImgList =response.data.costImgList
            this.saleList =response.data.saleList
            this.saleMonthList =response.data.saleMonthList || [];
//            this.saleMonthList =[];
            if(this.saleMonthList && this.saleMonthList.length > 0){
              for(var i=0;i<this.saleMonthList.length;i++){
                this.saleMonthList[i].U_Sort = i+1;
              }
            }

            this.flowRecordList = response.data.flowRecordList||[]
            this.reportImgList = response.data.reportImgList||[]

            this.isApply =(this.report.U_CreatedId==this.$wxuserUtil.getUserId())
            this.isApproval =(this.report.auditId==this.$wxuserUtil.getUserId())
            this.hasSalesMonth = this.saleMonthList.length > 0;
            console.log("hasSalesMonth:" + this.hasSalesMonth);

            this.isSalesMonthApproval = this.report.U_ApprovalStatus == 'Y' && this.report.U_ApprovedCnt == 1 && this.hasSalesMonth && this.isApproval && !this.isApply;
            console.log("isSalesMonthApproval:" + this.isSalesMonthApproval);
          }else{
            this.$title(`获取活动详情失败,${response.msg}`);
          }
        })
      },
      toReply(){
        this.$router.push('/active/reportApply?id='+this.$route.query.id)
      },
      sub(type){
        if(type==2 && !this.remark){
          this.$title('审批备注不能为空！');
          return
        }

        this.$api.$active.reportAudit({
          salesId:this.$wxuserUtil.getUserId(),
          'pojo.campReportId':this.$route.query.id,
          'pojo.remark':this.remark,
          'pojo.imgUrl':this.imgUrl,
          'pojo.auditType':type
        }).then(response=>{
          if(response.success==true){
            this.$title(`审批成功`);
            this.remark='' //审批备注
            this.imgs=[]
            this.imgUrl=''
            this.getDetail()
          }else{
            this.$title(`操作失败,${response.msg}`);
          }
        })
      },
      async afterRead(files){
        if(files.constructor === Array){
          if(files.length>99){
            this.$title('图片不能超过99张')
            return
          }
          for(var item of files){
            await this.onRead(item)
          }
        }else if(files.constructor === Object){
          this.onRead(files)
        }
      },
      async onRead(file){
        var fileSrc = file.file;

        var isImg = this.$wxuserUtil.validateIsImg(fileSrc);
        if(!isImg){
          return;
        }

        this.$toast({
          mask: true,
          message: '上传中...'
        });
        let lastFile = await imageCompression(fileSrc,this.$wxuserUtil.compressImgOptions);


        var formData = new FormData()
        formData.append('salesId',this.$wxuserUtil.getUserId())
        formData.append('file',lastFile)


        return  this.$api.uploadFile(formData).then(response=>{
          if(response.success==true){
            this.imgs.push(response.data.fileName)
          }else{
            this.$title(`图片上传失败,${response.msg}`);
          }
        })
      },
      delImg(index){
        this.imgs.splice(index,1)
      },
      getPdf(){
        this.$api.$active.reportPdf({
          salesId:this.$wxuserUtil.getUserId(),
          campReportId:this.$route.query.id,
        }).then(response=>{
          if(response.success==true){
            let url = response.data
            window.location.href=this.$config.serverURL+'/upload/'+url
          }else{
            this.$title(`操作失败,${response.msg}`);
          }
        })
      },
      previewList(list,index){
        console.log(list)
        let imgs =[]
        for(var item of list){
          if(item.U_url){
            imgs.push(this.$config.serverURL+'upload/'+item.U_url)
          }else{
            imgs.push(this.$config.serverURL+'upload/'+item)
          }
        }
        ImagePreview({
          images: imgs,
          startPosition: index,
        });
      },
      newSalesmonth(val){ //新增预算
        let obj = val
        if(!obj.U_Sort){
          obj.U_Sort = this.saleMonthList.length+1
          this.saleMonthList.push(JSON.parse(JSON.stringify(obj)))
        }else{
          for(var key in this.saleMonthList){
            if(obj.U_Sort==this.saleMonthList[key].U_Sort){
              this.saleMonthList.splice(key,1,obj)
            }
          }
        }
      },
      saleEdit(obj,index){
        if((this.isApply && !this.isSalesMonthApproval && !this.hasSalesMonth) || (this.report.U_ApprovalStatus=='MSM' && this.isApply)){
          if(obj){
            this.salesmonthValue=obj
          }
          this.showSalesmonth=!this.showSalesmonth
        }
      },
      submitSaleAfterMonth(){
          let data={
            salesId:this.$wxuserUtil.getUserId(),
            campReportId:this.$route.query.id,
            salesList:this.saleMonthList
          }
          if(this.saleMonthList.length<1){
              this.$title('活动后30天销售情况不能为空')
             return
          }
        for(var key in this.saleMonthList){
          data.salesList[key].productClass1 =this.saleMonthList[key].U_ProductClass1 || this.saleMonthList[key].productClass1Name;
          data.salesList[key].productName =this.saleMonthList[key].U_ProductName;
          data.salesList[key].amount =this.saleMonthList[key].U_Amount;
        }
          data = JSON.stringify(data)
          this.$api.$active.submitSaleAfterMonth(data).then(response=>{
            if(response.success==true){
              this.$title('提交成功')
              this.getDetail()
            }else{
              this.$title(`操作失败,${response.msg}`);
            }
          })
      }
    },
    created(){
      this.hasModifyAuth = this.$wxuserUtil.hasFunAuthByRoute(this.$route.path,this.$wxuserUtil.funcKey.Modified);
      this.hasAuditAuth =this.$wxuserUtil.hasFunAuthByRoute(this.$route.path,this.$wxuserUtil.funcKey.Audit);
      this.getDetail()
    }
  }
</script>
<style scoped lang="less" rel="stylesheet/less">
  @import "../../style/pageStyle/pageView-activeDetail.less";
  .van-cell__label{
    word-break:break-all;
  }
  .activeDetail .info .van-cell__title{
    width:70px;
    flex:none;
  }
  .group{
    margin-top: 10px;
  }
  .activeDetail{
    padding-bottom:55px;
  }
  .step-img{
    width:50px;
    height:50px;
    border-radius: 5px;
    margin:5px;
  }
  .steps{
    margin:10px 15px;
  .step{
    padding:10px 15px;
    position: relative;
  .step-icon{
    position: absolute;
    top:10px;
    left:-10px;
    z-index: 2;
  }
  }
  .step:not(:last-child):after{
    content:'';
    position: absolute;
    left:0px;
    width:0;
    height:100%;
    top:15px;
    border-left:1px solid #f2f2f2;
  }

  }
  .qrcode{
    text-align: center;
    img{
      width:60%;
    }
  }
  .list-card{
    margin:20px 10px;
    background-color: #fff;
    padding:10px;
    position:relative;
    border:1px solid #f2f2f2;
    border-radius: 20px;
  }
  .get-work{
    color:#ffa014;
  }
</style>



// WEBPACK FOOTER //
// src/components/active/reportDetail.vue